/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';


export function TagsDisplay ({tags, allowedTags}) {
    return <React.Fragment>
        {tags.filter(tag => (allowedTags || []).findIndex(allowed => ((tag.path || tag.tagId) || "").startsWith(allowed)) !== -1)
            .map(tag => tag.title || tag.tagLabel || tag)
            .join(", ")}
    </React.Fragment>
}

